import { render, staticRenderFns } from "./NoteTakerCard.vue?vue&type=template&id=6481fce5&scoped=true&"
import script from "./NoteTakerCard.vue?vue&type=script&lang=js&"
export * from "./NoteTakerCard.vue?vue&type=script&lang=js&"
import style0 from "./NoteTakerCard.vue?vue&type=style&index=0&id=6481fce5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6481fce5",
  null
  
)

export default component.exports